var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.44 3.973a8.116 8.116 0 01-2.607 1.02 4.055 4.055 0 00-2.996-1.33c-2.264 0-4.101 1.886-4.101 4.209 0 .33.037.651.106.956C8.43 8.652 5.407 6.98 3.383 4.433a4.29 4.29 0 00-.555 2.114c0 1.458.726 2.745 1.826 3.504a4.072 4.072 0 01-1.858-.524v.054c0 2.04 1.415 3.738 3.295 4.128a3.984 3.984 0 01-1.853.075c.523 1.671 2.034 2.889 3.834 2.92A8.11 8.11 0 012 18.447a11.432 11.432 0 006.291 1.89c7.551 0 11.674-6.408 11.674-11.973 0-.181-.005-.368-.01-.545A8.366 8.366 0 0022 5.64a8.002 8.002 0 01-2.355.662 4.228 4.228 0 001.794-2.329z",
    fill: "#121318"
  })));
}

export default SvgTwitter;